export enum BaseToastAlertClasses {
  success = 'bg-success text-white teaser px-2 py-0 m-0',
  error = 'bg-danger text-white teaser px-2 py-0 m-0',
  warning = 'bg-warning text-white teaser px-2 py-0 m-0',
  info = 'bg-info text-primary teaser px-2 py-0 m-0',
}
